<template>
    <DModal
        :title="__('customers.contracts.create_contract_tree.price')"
        is-confirm
        :show="showModal"
        is-medium
        @confirm="submitForm"
        @close="$emit('close-modal')"
    >
        <DCard
            padding
            class="price-form"
        >
            <DFormRow
                v-if="form.one_time_plan_selected === false"
                :label="__('customers.contracts.create_contract_tree.billing_cycle')"
                :is-required="true"
                :error="errors.billing_cycle"
            >
                <DSelect
                    id="billing_cycle"
                    v-model="form.billing_cycle"
                    :options="billingCycles"
                    :placeholder="__('customers.contracts.create_contract_tree.billing_cycle')"
                />
            </DFormRow>
            <DFormRow
                :label="__('customers.contracts.create_contract_tree.price')"
                :is-required="true"
                :error="errors.price"
            >
                <DInput
                    id="price"
                    v-model="form.price"
                    maxlength="13"
                    :placeholder="__('customers.contracts.create_contract_tree.price')"
                />
            </DFormRow>
            <DFormRow
                v-if="form.one_time_plan_selected === false"
                :label="__('customers.contracts.create_contract_tree.setup_fee')"
                :is-required="true"
                :error="errors.setup_fee"
            >
                <DInput
                    id="setup_fee"
                    v-model="form.setup_fee"
                    maxlength="13"
                    :placeholder="__('customers.contracts.create_contract_tree.setup_fee')"
                />
            </DFormRow>
            <hr>
            <DFormRow
                :label="''"
                :is-required="false"
            >
                <DRow>
                    <DCol sm="6">
                        <DButton
                            id="show_new_price"
                            :label="__('customers.contracts.create_contract_tree.new_price')"
                            class="after-cycle-button"
                            :color="showNewPriceAfter ? 'primary' : 'secondary'"
                            @click="showNewPrice"
                        />
                    </DCol>
                    <DCol sm="6">
                        <DButton
                            id="show_new_price_with_discount"
                            :label="__('customers.contracts.create_contract_tree.discount')"
                            class="after-cycle-button"
                            :color="showNewPriceWithDiscountAfter ? 'primary' : 'secondary'"
                            @click="showNewPriceWithDiscount"
                        />
                    </DCol>
                </DRow>
            </DFormRow>
            <div v-if="showNewPriceAfter">
                <DFormRow
                    :label="__('customers.contracts.create_contract_tree.new_price')"
                    :is-required="false"
                    :error="errors.new_price_price"
                >
                    <DInput
                        id="new_price"
                        v-model="newPrice.price"
                        maxlength="13"
                        :placeholder="__('customers.contracts.create_contract_tree.new_price')"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('customers.contracts.create_contract_tree.new_price_after')"
                    :is-required="false"
                    :error="errors.new_price_months"
                >
                    <DRow>
                        <DCol sm="4">
                            <DInput
                                id="new_months"
                                v-model="newPrice.months"
                                maxlength="13"
                                :placeholder="__('customers.contracts.create_contract_tree.new_price_after')"
                            />
                        </DCol>
                        <DCol
                            sm="8"
                            class="months"
                        >
                            {{ __('customers.contracts.create_contract_tree.months') }}
                        </DCol>
                    </DRow>
                </DFormRow>
            </div>
            <div v-if="showNewPriceWithDiscountAfter">
                <DFormRow
                    :label="__('customers.contracts.create_contract_tree.name')"
                    :error="errors.new_price_discount_name"
                >
                    <DInput
                        id="new_discount_name"
                        v-model="newPriceWithDiscount.discount_name"
                        maxlength="64"
                        :placeholder="__('customers.contracts.create_contract_tree.name')"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('customers.contracts.create_contract_tree.discount')"
                    :is-required="false"
                >
                    <DRow>
                        <DCol sm="6">
                            <DInput
                                id="new_discount_value"
                                v-model="newPriceWithDiscount.discount_value"
                                type="number"
                                min="0"
                                :placeholder="__('customers.contracts.create_contract_tree.discount')"
                            />
                            <p
                                v-if="errors.new_price_discount_value"
                                class="error-msg"
                            >
                                {{ errors.new_price_discount_value }}
                            </p>
                        </DCol>
                        <DCol sm="6">
                            <DSelect
                                id="new_discount_type"
                                v-model="newPriceWithDiscount.discount_type"
                                :options="discountTypes"
                                :placeholder="__('customers.contracts.create_contract_tree.discount_type')"
                            />
                            <p
                                v-if="errors.new_price_discount_type"
                                class="error-msg"
                            >
                                {{ errors.new_price_discount_type }}
                            </p>
                        </DCol>
                    </DRow>
                </DFormRow>
                <DFormRow
                    :label="__('customers.contracts.create_contract_tree.valid_for')"
                    :is-required="false"
                    :error="errors.new_price_months_with_discount"
                >
                    <DRow>
                        <DCol sm="4">
                            <DInput
                                id="new_with_discount_months"
                                v-model="newPriceWithDiscount.months"
                                maxlength="13"
                                :placeholder="__('customers.contracts.create_contract_tree.valid_for')"
                            />
                        </DCol>
                        <DCol
                            sm="8"
                            class="months"
                        >
                            {{ __('customers.contracts.create_contract_tree.months') }}
                        </DCol>
                    </DRow>
                </DFormRow>
            </div>
        </DCard>
    </DModal>
</template>

<script>

export default {
    name: 'PriceModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        billingCycles: {
            type: Array,
            default: () => { return [] }
        },
        discountTypes: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['close-modal', 'submitPrice'],
    data () {
        return {
            form: JSON.parse(JSON.stringify(this.contract)), // clone object
            showNewPriceAfter: false,
            showNewPriceWithDiscountAfter: false,
            newPrice: {
                price: null,
                discount_name: null,
                discount_type: null,
                discount_value: null,
                months: null
            },
            newPriceWithDiscount: {
                price: null,
                discount_name: null,
                discount_type: null,
                discount_value: null,
                months: null
            }
        }
    },
    created () {
        if (this.form.new_price_without_discount) {
            this.showNewPriceAfter = true
            this.newPrice.price = this.form.new_price_price
            this.newPrice.discount_name = this.form.new_price_discount_name
            this.newPrice.discount_type = this.form.new_price_discount_type
            this.newPrice.discount_value = this.form.new_price_discount_value
            this.newPrice.months = this.form.new_price_months
        }

        if (this.form.new_price_with_discount || this.form.new_price_discount_value !== null) {
            this.showNewPriceWithDiscountAfter = true
            this.newPriceWithDiscount.discount_name = this.form.new_price_discount_name
            this.newPriceWithDiscount.discount_type = this.form.new_price_discount_type
            this.newPriceWithDiscount.discount_value = this.form.new_price_discount_value
            this.newPriceWithDiscount.months = this.form.new_price_months_with_discount
        }
    },
    methods: {
        submitForm () {
            this.form.valid_from_month_required = false
            if (this.showNewPriceAfter) {
                this.form.valid_from_month_required = true
                this.setNewPrice()
            }

            if (this.showNewPriceWithDiscountAfter) {
                this.setNewPriceWithDiscount()
            }

            if (this.showNewPriceAfter === false && this.showNewPriceWithDiscountAfter === false) {
                this.form.new_price_with_discount = false
                this.form.new_price_without_discount = false
                this.form.new_price_price = null
                this.form.new_price_discount_name = null
                this.form.new_price_discount_type = null
                this.form.new_price_discount_value = null
                this.form.new_price_nett_price = null
                this.form.new_price_months = null
                this.form.new_price_months_with_discount = null
            }

            this.$emit('submitPrice', this.form)
        },
        showNewPrice () {
            this.showNewPriceAfter = !this.showNewPriceAfter
            this.showNewPriceWithDiscountAfter = false
        },
        showNewPriceWithDiscount () {
            this.showNewPriceAfter = false
            this.showNewPriceWithDiscountAfter = !this.showNewPriceWithDiscountAfter

            if (this.showNewPriceWithDiscountAfter === false) {
                this.form.new_price_price_with_discount = null
                this.form.new_price_discount_name = null
                this.form.new_price_discount_type = null
                this.form.new_price_discount_value = null
            } else {
                this.form.new_price_price_with_discount = this.form.price
                this.form.new_price_discount_name = this.contract.new_price_discount_name
                this.form.new_price_discount_type = this.contract.new_price_discount_type
                this.form.new_price_discount_value = this.contract.new_price_discount_value
            }
        },
        setNewPrice () {
            this.form.new_price_with_discount = false
            this.form.new_price_without_discount = true
            this.form.new_price_start_date = this.setStartDate(this.form.start_date, this.newPrice.months)
            this.form.new_price_price = this.newPrice.price
            this.form.new_price_price_with_discount = null
            this.form.new_price_months = this.newPrice.months
            this.form.new_price_months_with_discount = null
            this.form.new_price_discount_name = null
            this.form.new_price_discount_type = null
            this.form.new_price_discount_value = null
            this.form.new_price_nett_price = this.updatePrice(this.newPrice)
        },
        setNewPriceWithDiscount () {
            this.newPriceWithDiscount.price = this.form.price
            this.form.new_price_with_discount = true
            this.form.new_price_without_discount = false
            this.form.new_price_start_date = this.setStartDate(this.form.start_date, this.newPriceWithDiscount.months)
            this.form.new_price_price = null
            this.form.new_price_price_with_discount = this.form.price
            this.form.new_price_months = null
            this.form.new_price_months_with_discount = this.newPriceWithDiscount.months
            this.form.new_price_discount_name = this.newPriceWithDiscount.discount_name
            this.form.new_price_discount_type = this.newPriceWithDiscount.discount_type
            this.form.new_price_discount_value = this.newPriceWithDiscount.discount_value
            this.form.new_price_nett_price = this.updatePrice(this.newPriceWithDiscount)
        },
        updatePrice (newPrice, taxRate = 0) {
            return this.parseToFloat((newPrice.price - this.calculateDiscount(newPrice)) * (1 + taxRate / 100))
        },
        calculateDiscount (newPrice) {
            return newPrice.discount_type === 'fixed' ? newPrice.discount_value : (newPrice.discount_value / 100) * newPrice.price
        },
        parseToFloat (number) {
            return Number(number).toFixed(2)
        },
        setStartDate (date, months) {
            const newDate = new Date(date)
            const currentDate = newDate.getDate()
            newDate.setMonth(newDate.getMonth() + Number(months))
            if (newDate.getDate() !== currentDate) {
                newDate.setDate(0)
            }

            return this.getDateFormatted(newDate)
        },
        getDateFormatted (newDate) {
            const date = new Date(newDate)

            let day = date.getDate()
            let month = date.getMonth() + 1
            const year = date.getFullYear()

            if (month < 10) month = '0' + month
            if (day < 10) day = '0' + day

            return year + '-' + month + '-' + day
        }
    }
}
</script>

<style lang="scss" scoped>
.price-form {
    display: grid;
    grid-gap: 15px;
    border-radius: 0 !important;
    border-bottom: 0 !important;

    & .after-cycle-button {
        width: 100%;

        & > span {
            margin: 0 auto;
        }
    }

    & .months {
        margin: auto;
        padding-left: 0;
    }
}
.error-msg {
    padding-top: 3px;
    margin-bottom: 0;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
